/**
 * ハッシュ値がSHA-256であることを検証するバリデータ
 * 文字種と長さをチェックする
 * かっこのハッシュ値において英字は大文字
 * @param value
 * @returns
 */
export function hashSHA256Validator(value: any) {
  const regex = /^[A-Z0-9]{64}$/
  return regex.test(value)
}
